import { injectable } from 'inversify'

/**
 * Wraps Math.random (invariant 8: all browser APIs behind a gateway).
 */
@injectable()
export class RandomGateway {
  // [0, 1), same range as Math.random.
  next(): number {
    return Math.random()
  }
}
